module.exports = __webpack_public_path__ + "static/media/udaylog.2914fcdc.png";